import type { Resource } from '../../';
export const country_countries_LV: Resource = {"default":"Latvia"};
